import { render, staticRenderFns } from "./popovers.vue.js?vue&type=template&id=5a141fb4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=template&id=5a141fb4"
import script from "./popovers.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=script&lang=js"
export * from "./popovers.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a141fb4')) {
      api.createRecord('5a141fb4', component.options)
    } else {
      api.reload('5a141fb4', component.options)
    }
    module.hot.accept("./popovers.vue.js?vue&type=template&id=5a141fb4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=template&id=5a141fb4", function () {
      api.rerender('5a141fb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "popovers/components/popovers.vue"
export default component.exports